import { createContext, useContext } from 'react';
import type { Game } from '../../game/core/game';

export const GameContext = createContext<Game | null>(null);

export function useGameInstance(): Game | null {
  return useContext(GameContext);
}
